import AutoLink from './AutoLink';

export const SafeLink = AutoLink;
